import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { LockService } from '../services/lock.service';
import { PinDialogComponent } from '../pin-dialog/pin-dialog.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-lock-button',
    imports: [MatButtonModule, MatIconModule, CommonModule],
    template: `
    <button mat-fab extended (click)="lockScreen()" >
      <mat-icon>lock</mat-icon>
      Lock
    </button>
  `,
    styles: [`
    :host {
      display: block;
      margin: 10px;
    }
    button{
      height: 65px;
    }
    .mat-mdc-button-base ::ng-deep{
    font-size: 20px;
  }
  `]
})
export class LockButtonComponent {
  constructor(
    private lockService: LockService,
    private dialog: MatDialog
  ) {}

  lockScreen() {
    this.lockService.lock();
  }

}
